export default __webpack_public_path__ + "static/media/CreditDebitGrey.a15c7596.svg";